export default {
    data() {
        return {
            main: false,
            error_message_flag: false,
            curriculum_id: 0,
            discipline_id: 0,
            software: [],
            resources: [],
            data_bases: [],
            department_agreed: null,
            umu_agreed: null,
            library_agreed: null,
            software_agreed: null,
            period: {
                "Первый семестр": [1, 1],
                "Второй семестр": [1, 2],
                "Третий семестр": [2, 3],
                "Четвертый семестр": [2, 4],
                "Пятый семестр": [3, 5],
                "Шестой семестр": [3, 6],
                "Седьмой семестр": [4, 7],
                "Восьмой семестр": [4, 8],
                "Девятый семестр": [5, 9],
                "Десятый семестр": [5, 10],
                "Одиннадцатый семестр": [6, 11],
                "Двенадцатый семестр": [6, 12],
                "Первый год": [1, 1],
                "Первый год ": [1, 1],
                "Второй год": [2, 2],
                "Второй год ": [2, 2],
                "Третий год": [3, 3],
                "Третий год ": [3, 3],
                "Четвертый год": [4, 4],
                "Четвертый год ": [4, 4],
            },
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4] }],

                [{ size: ["small", false, "large"] }],

                ["bold", "italic", "underline"],

                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],

                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

                [{ script: "sub" }, { script: "super" }],

                [{ indent: "-1" }, { indent: "+1" }],

                ["link"],

                ["clean"]
            ],
            customContentToolbar: [

                ["bold", "italic", "underline"],

                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],

                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

                [{ script: "sub" }, { script: "super" }],

                [{ indent: "-1" }, { indent: "+1" }],

                ["link"],

                ["clean"]
            ],
            discipline_types: ["Общеобразовательная дисциплина", "Профессиональная дисциплина", "МДК", "Профессиональный модуль", "Учебная практика", "Производственная практика"],
            no_profile: [384,321,70,347,313,71,314,316,348,330,315,73,389,74,75,76,382,77,385,78,355,357,354,356,360,377,379,359,358,364,361,362,363,382,424],
        }
    },
    methods: {
        uniq(value, index, self) {
            return self.indexOf(value) === index;
        },
        aproval: function () {
            if (this.main_info.speciality_code.split('.')[1] !== '02' || this.main_info.speciality_code.split('.')[1] !== '04'){
                this.main_info.approval_date =  "";
                this.main_info.protocol_num = "";
            }
        }
    }
}